export default [
    {
        comment: '',
        error_id: 'FW 04',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: '',
        error_id: 'FW 05',
        data: [
            {cross_section: '4420', yr100: 256, fw: 250},
            {cross_section: '5505', yr100: 340, fw: 300},
        ]
    },
    {
        comment: '',
        error_id: 'FW 06',
        data: [
            {cross_section: '4420', YR100: {dn_text: 'Known WS', dn_value: '256.00'}, FW: {dn_text: 'Normal Depth S', dn_value: '0.002'}},
        ]
    }
]